/*eslint-disable import/no-anonymous-default-export*/
export default {
    GET_LOCATION: () => `/customer/getLocation`,
};

